import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { reasonsForResubmissionTitleAndOptions as titleAndOptions } from './reasonsForResubmissionTitleAndOptions';
const ReasonsForResubmission = _ref => {
  let {
    shouldRender,
    report,
    handleChange,
    handleSubmit,
    handleCheckChange
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderOptions = attribute => {
    return /*#__PURE__*/React.createElement(Row, {
      key: attribute.title,
      className: "mt-4"
    }, /*#__PURE__*/React.createElement(Col, {
      className: "ms-3"
    }, /*#__PURE__*/React.createElement("h3", {
      style: {
        fontSize: '1.2rem'
      }
    }, t(attribute.title)), attribute.options.map(option => {
      return /*#__PURE__*/React.createElement("div", {
        key: option
      }, /*#__PURE__*/React.createElement(Form.Check, {
        type: "checkbox",
        name: option,
        checked: report[option],
        value: report[option],
        onChange: e => handleCheckChange(e),
        label: t(option),
        "aria-label": option
      }));
    })));
  };
  if (!shouldRender) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: '1.4rem'
    },
    className: "mt-4"
  }, t('reasons_for_resubmission')), titleAndOptions.map(attribute => renderOptions(attribute)));
};
export default ReasonsForResubmission;